import { showedModal } from "@app/tracking/modals-tracking";
import type { NapiUser } from "@app/types/napi-types";
import type { SigningMethod } from "@app/types/tracking/account";
import { getTracker } from "@app/utils/window";

import { signedIn } from "../../../tracking/account-tracking";

export const signedInUser = (
  user: NapiUser,
  sign_in_method?: SigningMethod
) => {
  const tracker = getTracker();
  tracker.track(signedIn(user.id, sign_in_method));
};

export const sawAuthenticationModal = () => {
  const tracker = getTracker();
  tracker.track(showedModal("authentication"));
};
